class CartItems extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    init() {
        this.fetchRequestOpts = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }
        };

        this.cartSummary = document.querySelector('.cart-container .cart-summary');
        this.cartUpsells = document.querySelector('.cart-container cart-upsells');

        this.addEventListener('click', this.handleClick.bind(this));
        document.addEventListener('cart:updated', this.handleCartChange.bind(this));
    }

    handleCartChange(evt) {
        const eventDetail = evt.detail;

        if (eventDetail) {
            if (eventDetail.initiator == 'cart-items') return;

            const eventCart = eventDetail.cart;

            this.checkCartForUpsells();

            if (eventCart && eventCart.sections && eventCart.sections.cart) {
                return this.render(eventCart.sections.cart);
            }
        }

        return fetch('?section_id=cart', { method: 'POST' })
            .then((res) => res.text())
            .then((data) => this.render(data));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
        if (!evt.target.matches('.js-remove-item')) return;
        evt.preventDefault();
        this.updateQuantity(evt.target.dataset.index, 0);
    }

    setLoading(bool) {
        this.checkoutButton = this.cartSummary.querySelector('button[name="checkout"]');

        this.checkoutButton.classList.toggle('btn-loading', bool);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
        // clear all errors except this line's (which will be refreshed after this update)

        this.setLoading(true);

        const requestBody = {
            line,
            quantity,
            sections_url: window.location.pathname,
            sections: ['cart']
        };

        this.fetchRequestOpts.body = JSON.stringify(requestBody);

        let data;

        try {
            const lineItem = document.getElementById(`cart-item-${line}`);
            if (lineItem) {
                lineItem.remove();
            } else {
                console.warn(`Element with ID cart-item-${line} not found.`);
            }

            const response = await fetch(
                window.Shopify.routes.root + 'cart/change.js',
                this.fetchRequestOpts
            );

            data = await response.json();

            if (!response.ok) throw new Error(data.errors || response.status);

            //easiest way to show empty state
            if (typeof data.item_count !== 'undefined' && data.item_count === 0) {
                return window.location.reload();
            }
            this.render(data.sections.cart);
        } catch (error) {
            //display error message
            let errorMessage = '';
            if (/^[0-9]+$/.test(error.message)) {
                errorMessage = 'Error occured while changing cart, please try again.';
            } else {
                errorMessage = error.message;
            }
            console.error(error);

            if (errorMessage.length > 0) {
            }
        } finally {
            this.setLoading(false);

            this.dispatchEvent(
                new CustomEvent('cart:updated', {
                    bubbles: true,
                    detail: {
                        cart: data,
                        initiator: 'cart-items'
                    }
                })
            );

            this.checkCartForUpsells();
        }
    }

    render(html) {
        const elementHTML = CartItems.getElementHTML(html, ['cart-items', '.cart-summary', 'cart-upsells']);

        this.innerHTML = elementHTML['cart-items'];
        this.cartSummary.innerHTML = elementHTML['.cart-summary'];

        if (this.cartUpsells) {
            this.cartUpsells.innerHTML = elementHTML['cart-upsells'];
        }
    }

    slideToRemove(lineItem) {
        if (lineItem) {
            const lineItemHeight = lineItem.offsetHeight;

            lineItem.style.setProperty('--lineitem-height', `${lineItemHeight}px`);

            lineItem.classList.add('slide-out-left');

            lineItem.addEventListener('animationend', function () {
                lineItem.remove();
            });
        }
    }

    /**
     * Extracts the innerHTML of specified elements from a given HTML string.
     * @param {string} html - The HTML string to parse.
     * @param {string[]} selectors - An array of CSS selectors for the elements to extract the innerHTML from.
     * @returns {Object} An object where each key is a CSS selector from the input array and its value is the corresponding element's innerHTML. If an element is not found, its value will be null.
     */
    static getElementHTML(html, selectors) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = html;

        const htmlData = {};

        selectors.forEach(
            (selector) => (htmlData[selector] = tmpl.content.querySelector(selector)?.innerHTML)
        );
        return htmlData;
    }

    /* 
    Function to make sure cart only has upsells if there are canvas canvas products
    in card
     */
    checkCartForUpsells() {
        const upsellProducts = this.querySelectorAll('[data-upsell-product] .js-remove-item');
        if (upsellProducts.length === 0) return console.debug('no upsells in cart');

        const canvasProducts = this.querySelectorAll('[data-canvas-product]');

        if (canvasProducts.length === 0) {
            upsellProducts.forEach((product) => this.updateQuantity(product.dataset.index, 0));
        }
    }
}

customElements.define('cart-items', CartItems);
